import * as calendarTypes from "Store/calendar/constants";

const initialState: ICalendarReducer = {
  selectedCalendarItems: null,
  calendarAction: null,
  contextAction: { action: null, params: null }
};

const handleActions = (state, action) => {
  switch (action.type) {
    case calendarTypes.SET_SELECTED_CALENDAR_ITEMS:
      return {
        selectedCalendarItems: action.payload
      };
    case calendarTypes.SET_CALENDAR_ACTION:
      return {
        calendarAction: action.payload
      };

    case calendarTypes.SET_CALENDAR_CONTEXT_ACTION:
      return {
        contextAction: { ...action.payload }
      };
    default:
      return {};
  }
};

const calendarReducer = (state = initialState, action) => ({
  ...state,
  ...handleActions(state, action)
});

export default calendarReducer;
